// CP-Inspiration/InspirationBreadcrumb.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const InspirationBreadcrumb = ({ competenceId, currentPage = 'orientation' }) => {
  const navigate = useNavigate();

  const pageLabels = {
    orientation: 'Orientation',
    search: 'Recherche 360°',
    synthesis: 'Synthèse'
  };

  if (!competenceId) return null;

  return (
    <div className="mb-6">
      <nav className="flex items-center space-x-2 text-sm">
        <button
          onClick={() => navigate(`/inspiration/${competenceId}`)}
          className="text-purple-600 hover:text-purple-700 font-medium transition-colors"
        >
          Parcours d'inspiration
        </button>
        <span className="text-gray-400">/</span>
        <span className="text-gray-700 font-medium">
          {pageLabels[currentPage]}
        </span>
      </nav>
    </div>
  );
};

export default InspirationBreadcrumb;